// @flow
import React, { useState, useEffect, useRef } from 'react';
import type { Node } from 'react';
import Spinner from '../ui/Spinner';

const defaultLoadingComponent = <Spinner isLoading={true} />;

type Props = $ReadOnly<{
    children: Node,
    showLoading?: boolean,
    loadingComponent?: Node
}>;
function DeferRender({ showLoading = true, loadingComponent = defaultLoadingComponent, children }: Props) {
    const [mounted, setMounted] = useState();
    const unmountedRef = useRef();

    useEffect(() => {
        if(typeof window !== 'undefined' && window.requestAnimationFrame) {
            window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                    if(!unmountedRef.current) {
                        setMounted(true);
                    }
                });
            });
        }
        else {
            setMounted(true);
        }

        return () => {
            unmountedRef.current = true;
        };
    }, []);

    return mounted ?
        children
        :
        showLoading ? loadingComponent : null;
}

export default DeferRender;